import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

import moment from "moment";

import summaryApi from "../../apis/Summary.api";

import { negativeColor, positiveColor } from "./BannerAlgorithm";

const MonthTraffic = () => {
	const user = useSelector((state) => state.auth.user);
	// const [loading, setLoading] = useState(false);

	const [userMoveValue, setUserMoveValue] = useState({
		inflow: 0,
		signup: 0,
		compare_inflow: 0,
	});

	const [compareList, setCompareList] = useState([
		{
			name: "좋아요",
			count: 0,
			condition: 0,
		},
		{
			name: "댓글",
			count: 0,
			condition: 0,
		},
		{
			name: "조회수",
			count: 0,
			condition: 0,
		},
	]);

	useEffect(() => {
		if (user?.id) {
			const timer = setTimeout(() => {
				getStatistics();
			}, 100);
			return () => clearTimeout(timer);
		}
	}, [user]);

	const getStatistics = useCallback(async () => {
		// setLoading(true);
		const param = {
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			startDate: moment()
				.subtract(1, "months")
				.startOf("months")
				.format("YYYYMMDDHHmm"),
			endDate: moment().endOf("months").format("YYYYMMDDHHmm"),
			dateType: "monthly",
		};

		const res = await summaryApi.readDashboardUserThatTime(param);
		if (res.code === 200) {
			let list = res.result?.userSummaryList;
			let reverse = list.reverse();
			let now = reverse[0];
			let before = reverse[1];

			setCompareList([
				{
					name: "좋아요",
					count: now?.favorite_num,
					condition: now?.favorite_num - before?.favorite_num ?? 0,
				},
				{
					name: "댓글",
					count: now?.comment_num,
					condition: now?.comment_num - before?.comment_num ?? 0,
				},
				{
					name: "조회수",
					count: now?.view_num,
					condition: now?.view_num - before?.view_num ?? 0,
				},
			]);
			setUserMoveValue({
				inflow: now?.inflow_num,
				signup: now?.signup_num,
				compare_inflow: now?.inflow_num - before?.inflow_num ?? 0,
			});
		}
		// setLoading(false);
	}, []);

	return (
		<div className={`dashboard-component`} style={{ width: "100%" }}>
			<h3>이번 달 유입량 / 참여율</h3>
			<div className={`dashboard-component-chart-bottom`}>
				<div className={`dashboard-big-price-div`}>
					{/* 이번 달 유입량 표기 */}
					<div className={`dashboard-point-with-img-div align-start`}>
						<p className={`dark-gray`}>이번 달 유입량</p>
						<div
							style={{
								display: "flex",
								alignItems: "baseline",
								gap: 5,
							}}
						>
							<h1>{userMoveValue?.inflow?.toLocaleString()}</h1>
							<b>회</b>
							<img
								src={`/assets/images/dashboard/${
									userMoveValue?.compare_inflow > 0
										? "blue-up"
										: userMoveValue?.compare_inflow < 0
										? "red-down"
										: "middle"
								}.png`}
								alt={`대시보드 경고 아이콘`}
								style={{
									width: "1.8em",
									height: "1.8em",
									marginLeft: 5,
								}}
							/>
						</div>
						<p className={`dark-gray`}>
							지난달 대비
							<span
								style={{
									color:
										userMoveValue?.compare_inflow > 0
											? // ? "#df1d1d"
											  positiveColor
											: userMoveValue?.compare_inflow < 0
											? // ? "#117ffb"
											  negativeColor
											: "inherit",
								}}
							>
								{" "}
								{Math.abs(
									userMoveValue?.compare_inflow
								)?.toLocaleString()}회{" "}
								{userMoveValue?.compare_inflow >= 0 ? "증가" : "감소"}
							</span>
						</p>
					</div>

					{/* 좋아요, 댓글, 조회수 - mobile-hidden */}
					<div className={`dashboard-point-with-img-div point-list`}>
						{compareList?.map((item, idx) => (
							<div
								style={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									width: "100%",
									padding: "0.5em 0 0.5em 1.2em",
								}}
								key={`dashboard-month-${idx}`}
							>
								<p className={`dark-gray`}>{item.name}</p>
								<div style={{ display: "flex", alignItems: "center" }}>
									<p>{item.count?.toLocaleString()}</p>
									<img
										src={`/assets/images/dashboard/${
											item?.condition > 0
												? "up"
												: item?.condition < 0
												? "down"
												: "middle"
										}.png`}
										alt={`대시보드 경고 아이콘`}
										style={{
											width: "1.1em",
											height: "1.1em",
											marginLeft: 6,
										}}
									/>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>

			{/* 좋아요, 댓글, 조회수 - mobile-show */}
			<div className={`dashboard-point-with-img-div point-list-mobile`}>
				{compareList?.map((item, idx) => (
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							width: "100%",
							padding: "0.5em 0",
						}}
						key={`dashboard-month-mobile-${idx}`}
					>
						<p className={`dark-gray`}>{item.name}</p>
						<div style={{ display: "flex", alignItems: "center" }}>
							<p>{item.count?.toLocaleString()}</p>
							<img
								src={`/assets/images/dashboard/${
									item?.condition > 0
										? "up"
										: item?.condition < 0
										? "down"
										: "middle"
								}.png`}
								alt={`대시보드 경고 아이콘`}
								style={{
									width: "1.1em",
									height: "1.1em",
									marginLeft: 6,
								}}
							/>
						</div>
					</div>
				))}
			</div>

			<div className={`dashboard-component-footer`}>
				<Link to={`/user_manage`} className={`dashboard-footer-font`}>
					회원관리로 이동
				</Link>
			</div>
		</div>
	);
};

export default MonthTraffic;
